module.exports = __webpack_public_path__ + "static/img/mail.c0188e4a.png";